import { render, staticRenderFns } from "./BusinessWalletAccount.vue?vue&type=template&id=37160d50&"
import script from "./BusinessWalletAccount.vue?vue&type=script&lang=js&"
export * from "./BusinessWalletAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports